import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Orgstyle } from '../model/orgstyle';

@Injectable({
  providedIn: 'root'
})
export class OrgstyleService {

  serviceUrl:string = environment.apiUrl+'/organization/' + SessionHelper.getChoosenOrg();
  constructor(private http:HttpClient) { }

  getOrgstyleByOrgId(orgId: string) {
    return this.http.get<any>(`/api/orgs/${orgId}/style`);
  }

  getOrgstyles(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgstyle[]>(this.serviceUrl+'/whitelabel/list',httpOptions);
  }

  getOrgstyle(style:Orgstyle){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgstyle>(this.serviceUrl+'/whitelabel/'+style.whitelabelId,httpOptions);
  }

  createOrgstyle(style:Orgstyle){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<string>(this.serviceUrl+'/whitelabel',style,httpOptions);
  }  

  updateOrgstyle(style:Orgstyle){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.patch<string>(this.serviceUrl+'/whitelabel/'+style.whitelabelId,style,httpOptions);
  } 

  deleteOrgstyle(style:Orgstyle){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(this.serviceUrl+'/whitelabel/'+style.whitelabelId,httpOptions);
  } 
  getDefaultOrgStyle(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgstyle>('./assets/assets/defaultorgstyle.html',httpOptions)
  }
}
